module.exports = __webpack_public_path__ + "img/step_45_white_lebel.fae6bede.png";